module.exports = __webpack_public_path__ + "images/questions/qa_title_matome_acebd88263c72c929588d57bc20ff799.png";